import store from '@ps/store'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { EditorDataScript } from '@ps/bridge/qc/scripts/editor'
import { IvBrain, IvBrainItem, IvBrainLink, NodeAction } from './types'
import { IvLinkType } from './enums'
import { IvNodeUuid } from '../timeline/types'
import { IvSegmentType } from '../timeline/enums'
import _ from 'lodash'
import qc from 'qc'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
import { scripts } from '@ps/bridge/qc/scripts'
import { addEventItem } from '../event/event'
import { EventType } from '@ps/bridge/qc/vp/config'
import nodePool from '@ps/bridge/qc/node-pool'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
import {
  coverScreen,
  setNodeStyleMerge,
  setNodeStyleMergeVH,
} from '@ps/bridge/qc/node/layout'
import assets from '@ps/bridge/qc/assets'
import gameIframe from '@ps/bridge/iframe/iframe'
import { addTextComponent, ivGroupNodePos } from '../common/utils'
import { textPrefab } from '../common/config'
import { VpVideoMethods } from '@ps/bridge/qc/vp/config'
import { VpMethods } from '@ps/bridge/qc/vp/config'
import { IvSyncStatus } from '@ps/store/interactive-video/brain/enums'
import {
  updateSegmentIvTypeToScene,
  removeSegmentIvToScene,
  updateSegmentToScene,
  addEndSegmentToScene,
} from '@ps/store/interactive-video/timeline/utiles/scene'
import { generateEmptyNode } from '@ps/bridge/qc/node/utils'
import { addSegmentOtherToSceneByStore } from '@ps/store/interactive-video/timeline/utiles/scene'
import * as nodeUtils from '@ps/store/workbench/common/node-utils'
import { isIvPage } from '@ps/router/config'
import * as sceneConfigScript from '@ps/bridge/qc/scripts/scene-config'
import { isIvEndingInstallNode } from '@ps/bridge/qc/base'
import { unitTypeOptions } from './config'
import { Message } from 'element-ui'
import i18n from '@ps/lang'
import { Event, EventBus } from '@ps/utils/event-bus'
import { getSameVideoScene } from '@ps/store/interactive-video/brain/sync'
import { poolVideoGetConfigByPath } from '@ps/bridge/resource/pool'
import { isSceneError } from '../timeline/utiles/scene-error'
import {
  getIvCurSceneVideoNode,
  isLastNormalScene,
  setTimeline,
} from '@ps/store/interactive-video/timeline/timeline'

/**
 * 从游戏持久化数据中获取脑图数据
 * @returns 脑图数据
 */
export function getBrainData(): IvBrain {
  const gamePlay = store.getters['workspace/game/gamePlay']
  const ped = editorScript.getScript(gamePlay) as EditorDataScript
  if (ped.$data.brain) {
    return Object.values(ped.$data.brain)
  }
  return []
}

/**
 * 设置脑图数据到游戏持久化字段中
 * @param data 脑图数据
 */
export function setBrainData(data: IvBrain) {
  const gamePlay = store.getters['workspace/game/gamePlay']
  const ped = editorScript.getScript(gamePlay) as EditorDataScript
  ped.$data.brain = data
}

/**
 * 获取完整的分支信息
 * @param sceneUuid 当前点选的场景
 * @param brainData 脑图数据
 */
export function getWholeBranch(
  sceneUuid: IvNodeUuid,
  brain: IvBrain,
): IvNodeUuid[] {
  // 梳理出每个节点的parent信息
  const brainData = _.cloneDeep(brain)
  for (const i in brainData) {
    for (const j in brainData[i].actions) {
      const uuid = brainData[i].actions[j].targetUuid
      const index = brainData.findIndex((item) => item.sceneUuid === uuid)
      brainData[index].parent = brainData[i].sceneUuid
    }
  }
  const res = [sceneUuid]
  // 找祖先节点
  let index = brainData.findIndex((item) => item.sceneUuid === sceneUuid)
  if (index === -1) return res
  while (brainData[index].parent) {
    res.unshift(brainData[index].parent)
    index = brainData.findIndex(
      (item) => item.sceneUuid === brainData[index].parent,
    )
  }
  // 找子孙节点
  index = brainData.findIndex((item) => item.sceneUuid === sceneUuid)
  while (brainData[index].actions.length > 0) {
    res.push(brainData[index].actions[0].targetUuid)
    index = brainData.findIndex(
      (item) => item.sceneUuid === brainData[index].actions[0].targetUuid,
    )
  }

  return res
}
// 计算出脑图的各种统计数据
export function getFinalBrain() {
  const brain = store.state.ivBrain.brainData
  let branchNum = 0
  let layerNum = 0
  // 梳理出每个节点的parent信息
  const brainData = _.cloneDeep(brain)
  for (const i in brainData) {
    for (const j in brainData[i].actions) {
      const uuid = brainData[i].actions[j].targetUuid
      const index = brainData.findIndex(
        (item: IvBrainItem) => item.sceneUuid === uuid,
      )
      // eslint-disable-next-line no-continue
      if (index === -1) continue
      brainData[index].parent = brainData[i].sceneUuid
    }
  }
  // 叶子节点的数量就是分支数量
  for (const i in brainData) {
    if (brainData[i].actions.length === 0) {
      branchNum++
      const num = getLayerNum(brainData[i])
      if (num > layerNum) {
        layerNum = num
      }
    }
  }
  // 计算脑图结构,每一层有多少个节点
  const structure = new Array(layerNum)
  for (const i in brainData) {
    const num = getLayerNum(brainData[i])
    if (typeof structure[num - 1] === 'undefined') {
      structure[num - 1] = 0
    }
    structure[num - 1]++
  }
  // 计算当前节点所在的层数
  function getLayerNum(node) {
    const res = [node]
    // 找祖先节点
    let index = brainData.findIndex(
      (item: IvBrainItem) => item.sceneUuid === node.sceneUuid,
    )
    while (brainData[index].parent) {
      res.unshift(brainData[index].parent)
      index = brainData.findIndex(
        (item: IvBrainItem) => item.sceneUuid === brainData[index].parent,
      )
    }
    return res.length
  }
  const res = {
    branchNum,
    layerNum,
    structure,
    data: brain,
  }
  return res
}

export function addBrainItem(pid: IvNodeUuid) {
  if (pid) {
    // 添加父节点连接热区
  }
  // generateBrainItem
  // link linkBrainItem
}

export function generateBrainItem(
  node: qc.Node,
  linkNode: qc.Node,
  isEnd: boolean,
) {
  // init brain data
  return {
    sceneUuid: node.uuid,
    link: {
      type: IvLinkType.Interactive,
      id: linkNode.uuid,
      interactiveType: IvSegmentType.Freeze,
    },
    actions: [],
    videoUuid: '',
    sync: 0,
    isEnd,
  }
}

export function linkBrainItem(
  fromUuid: IvNodeUuid,
  toUuid: IvNodeUuid,
  data: IvBrainItem[],
) {
  const hotSpot = addSceneHotSpot(fromUuid, toUuid)
  data.forEach((item) => {
    // 对于从元素添加 actions 字段，存储连接信息
    if (item.sceneUuid === fromUuid) {
      item.actions.push({
        nodeUuid: hotSpot ? hotSpot.uuid : '',
        targetUuid: toUuid,
      })
    }
  })
  return {
    hotSpot,
  }
}

export const IV_HOTAREA_GROUP_NAME = 'iv_hotArea_group'
export const IV_SCENE_LINK_NODE_NAME = 'iv_link_node'

export function isIvSceneLinkNode(node: qc.Node): boolean {
  if (!node) return false
  const brain = store.state.ivBrain.brainData
  const brainItem = brain.find(
    (item: IvBrainItem) => item.link.id === node.uuid,
  )
  if (brainItem) {
    return true
  }
  return false
}

export async function initIvEndingScene(node: qc.Node) {
  const gameOb = store.state.workspace.game.data.gameOb
  const Texture = gameIframe.qc.Texture
  // 更新结束场景场景属性
  await store.dispatch('workspace/sceneManager/updateSceneConfigScript', {
    uuid: node.uuid,
    config: {
      isEnding: true,
    },
    record: false,
  })
  const res = gameOb.assets.find('__builtin_resource__')
  const emptyTexture = res.getTexture('empty.png')
  // 背景图
  let asset = await assets.load({
    url: 'resource/game/texture/ivMask.bin',
  })
  const bgImage = gameOb.add.image(node)
  bgImage.name = 'iv_ending_bg'
  resetNodeDefaultLayout(bgImage)
  coverScreen(bgImage, { width: 1334, height: 1334 })
  bgImage.texture = new Texture(asset, 0)
  bgImage.alpha = 0.5
  // logo
  const appLogo = gameOb.add.image(node)
  appLogo.name = 'iv_ending_app_logo'
  asset = await assets.load({
    url: 'resource/game/texture/ivAppLogo.bin',
  })
  appLogo.texture = new Texture(asset, 0)
  appLogo.resetNativeSize()
  setNodeStyleMergeVH(appLogo, {
    pdef: {
      x: 0,
      y: -150,
    },
    ldef: {
      x: 0,
      y: -150,
    },
  })

  // cta按钮
  const ctaBtn = gameOb.add.image(node)
  ctaBtn.name = 'iv_ending_cta_btn'
  asset = await assets.load({
    url: 'resource/game/texture/ivCtaBtn.bin',
  })
  ctaBtn.texture = new Texture(asset, 0)
  ctaBtn.resetNativeSize()
  setNodeStyleMergeVH(ctaBtn, {
    pdef: {
      x: 0,
      y: 150,
    },
    ldef: {
      x: 0,
      y: 150,
    },
  })
  // App Name
  const appTextNode = await addTextComponent(textPrefab, node)
  appTextNode.name = 'appName'
  store.dispatch('workspace/game/setText', {
    node: appTextNode,
    value: 'APP NAME',
    record: false,
  })
  store.dispatch('workspace/game/setStyle', {
    nodes: {
      uuid: appTextNode.uuid,
      alignH: 2,
      color: 'rgba(255,255,255,1)',
    },
    record: false,
  })
  // Download
  const downloadTextNode = await addTextComponent(textPrefab, node)
  downloadTextNode.name = 'download'
  store.dispatch('workspace/game/setText', {
    node: downloadTextNode,
    value: 'Download',
    record: false,
  })
  store.dispatch('workspace/game/setStyle', {
    nodes: {
      uuid: downloadTextNode.uuid,
      alignH: 2,
      color: 'rgba(255,255,255,1)',
      bold: true,
      strokeThickness: 12,
      stroke: 'rgba(202,108,0,1)',
    },
    record: false,
  })
  setTimeout(() => {
    setNodeStyleMergeVH(appTextNode, {
      pdef: {
        x: 0,
        y: 0,
      },
      ldef: {
        x: 0,
        y: 0,
      },
    })
    setNodeStyleMergeVH(downloadTextNode, {
      pdef: {
        x: 0,
        y: 150,
      },
      ldef: {
        x: 0,
        y: 150,
      },
    })
  }, 360)

  // 跳转热区节点
  const installNode = gameOb.add.image(node)
  installNode.name = 'iv_ending_install_hotarea'
  setNodeStyleMergeVH(installNode, {
    pdef: {
      width: 320,
      height: 160,
      x: 0,
      y: 150,
    },
    ldef: {
      width: 320,
      height: 160,
      x: 0,
      y: 150,
    },
  })
  const ped = editorScript.getScript(installNode)
  ped.$data.nodeType = editorScript.nodeTypes.ivEndingInstall
  installNode.texture = emptyTexture
  installNode.addScript(scripts.emptyNode.name)
  addEventItem({
    conditionNode: installNode,
    actionNode: installNode,
    handCmd: EventType.down,
    action: 'vpInstall',
    sceneNode: node,
  })
  return installNode
}

function addSceneLinkNode(sceneNode: qc.Node): qc.Node {
  const gameOb = store.state.workspace.game.data.gameOb
  const linkNode = gameOb.add.node(sceneNode)
  linkNode.name = IV_SCENE_LINK_NODE_NAME // 场景跳转节点，用于辅助选中场景的跳转元件，无展示作用
  linkNode.width = 0
  linkNode.height = 0
  linkNode.visible = false
  // const ped = editorScript.getScript(linkNode)
  // ped.$data.nodeType = editorScript.nodeTypes.ivHotArea
  return linkNode
}

// 切换场景间互动元件脑图数据、节点处理逻辑
export function switchIvSegmentBrainData({
  nodeUuid,
  sceneUuid,
  type,
  interactiveType,
  brainData,
}: {
  nodeUuid: IvNodeUuid
  sceneUuid: IvNodeUuid
  type: IvLinkType
  interactiveType: IvSegmentType.Freeze | IvSegmentType.Loop
  brainData: IvBrainItem
}) {
  const spots: qc.Node[] = []
  const spotAction: NodeAction = {
    action: '', // add,delete
    spots: [],
  }
  // 检查互动元件切换是否涉及热区变更
  const isSpotChange = () => {
    return (
      [brainData.link.type, type].some((el) => el === IvLinkType.Auto) &&
      brainData.link.type !== type
    )
  }
  if (isSpotChange() && type === IvLinkType.Auto) {
    // 互动切自动，删除热区、元件
    brainData?.actions.forEach((action) => {
      spots.push(nodePool.find(action.nodeUuid as IvNodeUuid))
    })
    brainData.link.type = type
    brainData.link.interactiveType = ''
    brainData.actions = brainData.actions.map((item) => {
      delete item.nodeUuid
      return {
        ...item,
      }
    })
    spotAction.action = 'delete'
    spotAction.spots = spots
    // 更新时间轴
    removeSegmentIvToScene(sceneUuid, nodeUuid)
  } else if (isSpotChange() && brainData.link.type === IvLinkType.Auto) {
    // 自动切互动，新增热区、元件
    brainData.actions.forEach((action) => {
      const temp = addSceneHotSpot(
        brainData.sceneUuid,
        action.targetUuid,
        false,
      )
      action.nodeUuid = temp.uuid
      spots.push(temp)
    })
    brainData.link.type = type
    brainData.link.interactiveType = interactiveType
    spotAction.action = 'add'
    spotAction.spots = spots
    // 更新时间轴
    const addRes = addEndSegmentToScene(sceneUuid, brainData.link)
    // 自动跳转切其他互动类型时，有可能失败，要还原之前的状态
    if (isSceneError(addRes)) {
      // 删除上面新建的热区节点
      if (spots[0]) {
        spots[0].removeSelf()
      }
      // 脑图还原
      brainData.actions.forEach((action) => {
        delete action.nodeUuid
      })
      spotAction.spots = []
      spotAction.action = ''
      brainData.link.type = IvLinkType.Auto
      brainData.link.interactiveType = ''
      Message.error(addRes.message)
      return { spotAction, fail: true }
    }
  } else {
    brainData.link.interactiveType = interactiveType
    // 更新时间轴
    updateSegmentIvTypeToScene({
      nodeUuid,
      sceneUuid,
      type: interactiveType,
    })
  }
  return {
    spotAction,
  }
}

// 初始化互动视频编辑器场景节点
export async function initIvScene(state: any, node: qc.Node, isEnd: boolean) {
  const gameOb = store.state.workspace.game.data.gameOb
  if (!isEnd) {
    // 创建热区组
    const hotAreaGroupNode = gameOb.add.node(node)
    hotAreaGroupNode.name = IV_HOTAREA_GROUP_NAME
    const ped = editorScript.getScript(hotAreaGroupNode)
    ped.$data.nodeType = nodeTypes.ivGroup
    ivGroupNodePos(hotAreaGroupNode)
    const layout = hotAreaGroupNode.getScript('ps.Layout')
    if (layout) {
      hotAreaGroupNode.removeScript(layout)
    }
  }
  const linkNode = addSceneLinkNode(node)
  let installNode
  // 结束场景初始化逻辑
  if (isEnd) {
    node.visible = false // 先隐藏场景，待生成好结束场景里的节点后才显示
    installNode = await initIvEndingScene(node)
  }
  return {
    linkNode: linkNode,
    installNode,
  }
}

// 获取场景中热区组节点
export function getSceneHotSpotGroup(node: qc.Node): qc.Node | null {
  const children = node.children || []
  return (
    children.find((item) => item.name.indexOf(IV_HOTAREA_GROUP_NAME) > -1) ||
    null
  )
}

// 判断是否场景间的跳转热区
export function isSceneToSceneSpot(uuid: IvNodeUuid, brain: IvBrainItem) {
  const uuids = brain.actions
    .map((item) => item.nodeUuid || '')
    .concat(brain.link.id)
  return uuids.some((item) => item === uuid)
}

export function addSceneHotSpot(
  uuid: IvNodeUuid,
  targetUuid?: IvNodeUuid,
  needEvent = true,
) {
  const gameOb = store.state.workspace.game.data.gameOb
  const sceneNode = nodePool.find(uuid)
  const spotGroup = getSceneHotSpotGroup(sceneNode) as qc.Node
  const spotNode = generateEmptyNode(spotGroup, gameOb)
  spotNode.width = 200
  spotNode.height = 200
  // 要加个layout的visible，不然layout为空，复制粘贴元件后，目标元件的layout里的visible为0
  setNodeStyleMerge(spotNode, {
    visible: 1,
  })
  const ped = editorScript.getScript(spotNode)
  if (ped) {
    ped.$data.nodeType = nodeTypes.ivHotArea
  }
  if (needEvent) {
    if (targetUuid) {
      // 场景间互动元件事件,在actionHandler里加事件，这里不重复添加
      // addEventItem({
      //   conditionNode: spotNode,
      //   actionNode: spotNode,
      //   handCmd: EventType.down,
      //   action: VpMethods.vpSwitchScene,
      //   param: {
      //     jumpSceneId: targetUuid,
      //   },
      // })
    } else {
      // 场景内互动元件事件
      const videoNode = getIvCurSceneVideoNode()
      addEventItem({
        conditionNode: spotNode,
        actionNode: videoNode,
        handCmd: EventType.down,
        action: VpVideoMethods.vpResumeVideo,
      })
    }
  }
  return spotNode
}

// 根据其中一个场景间的热区节点，获取当前场景中所有场景间跳转的热区节点
export function getRelativeHotAreaNode(nodeUuid: string): qc.Node[] {
  const node = nodePool.find(nodeUuid)
  const res = [node]
  const brain = store.state.ivBrain.brainData
  const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
  const brainItem = brain.find(
    (item) => item.sceneUuid === currentSceneNode.uuid,
  )
  const hotArea = brainItem.actions.find((item) => item.nodeUuid === nodeUuid)
  if (hotArea) {
    const nodes = brainItem.actions.map((item) => item.nodeUuid)
    nodes.forEach((item) => {
      if (res.indexOf(item) === -1) {
        res.push(item)
      }
    })
  }
  return res
}
// 节点是不是场景间跳转的热区节点
export function isEndHotAreaNode(
  sceneNodeUuid: string,
  nodeUuid: string,
): boolean {
  const uuids = getEndHotAreaNode(sceneNodeUuid)
  return uuids.indexOf(nodeUuid) > -1
}

/**
 * 根据热区节点获取场景间跳转的热区节点组uuid
 * @param hotAreaNodeUuid
 * @returns
 */
export function getEndHotAreaNodeGroupUuid(
  hotAreaNodeUuid: IvBrainLink['nodeUuid'],
): IvBrainItem['link']['id'] | undefined {
  const brain: IvBrain = store.state.ivBrain.brainData
  const brainItem = brain.find((item) => {
    return item.actions.some((action) => action.nodeUuid === hotAreaNodeUuid)
  })

  return brainItem?.link.id
}

// 获取场景间跳转的热区节点
export function getEndHotAreaNode(sceneNodeUuid: string): string[] {
  const brain = store.state.ivBrain.brainData
  const brainItem = brain.find((item) => {
    return item.sceneUuid === sceneNodeUuid
  })
  return brainItem.actions
    .map((item) => {
      return item.nodeUuid
    })
    .filter((item) => {
      return !!item
    })
}

// 是否场景间跳转的辅助节点
export function isSceneToSceneLinkNode(uuid: string): boolean {
  const brain = store.state.ivBrain.brainData
  const brainItem = brain.find((item) => {
    return item.link.id === uuid
  })
  return !!brainItem
}

// 添加互动视频资源，通用资源结构包装
export async function wrapAddIvNode(
  sceneNode: qc.Node,
  node: qc.Node,
  index: number,
) {
  if (!isIvPage()) return ''
  const gameOb = store.state.workspace.game.data.gameOb
  // 互动视频资源添加逻辑
  let ivGroupNode = null
  let tempIndex = index
  const resourceSegment = addSegmentOtherToSceneByStore(
    node.uuid,
    sceneNode.uuid,
  )
  if (resourceSegment && resourceSegment.groupId) {
    ivGroupNode = nodePool.find(resourceSegment.groupId)
    nodeUtils.switchParentAndRefresh({
      parent: ivGroupNode,
      nodes: [node],
      index: ivGroupNode.children.length,
    })
    tempIndex = sceneNode.getChildIndex(ivGroupNode)
  } else {
    const hotAreaGroupNode = sceneNode.children.find(
      (item) => item.name === IV_HOTAREA_GROUP_NAME,
    ) as qc.Node
    if (hotAreaGroupNode) {
      tempIndex = sceneNode.getChildIndex(hotAreaGroupNode)
    }
    ivGroupNode = gameOb.add.node(sceneNode)
    ivGroupNode.name = 'group'
    const ped = editorScript.getScript(ivGroupNode)
    ped.$data.nodeType = nodeTypes.ivGroup
    ivGroupNodePos(ivGroupNode)
    node.switchParent(ivGroupNode, 0)
    updateSegmentToScene(sceneNode.uuid, node.uuid, {
      groupId: ivGroupNode.uuid,
    })
    // 新增组移动到热区之前
    nodeUtils.switchParentAndRefresh({
      parent: sceneNode,
      nodes: [ivGroupNode],
      index: tempIndex,
    })
  }
  setTimeout(() => {
    // node-utils里的switchParent延后300ms才设置另一个屏幕的layout，但是又不是居中，这里先强制居中
    setNodeStyleMerge(ivGroupNode, {
      x: 0,
      y: 0,
    })
    setNodeStyleMerge(node, {
      x: 0,
      y: 0,
    })
    const layout = ivGroupNode.getScript('ps.Layout')
    if (layout) {
      ivGroupNode.removeScript(layout)
    }
  }, 350)
  return {
    ivGroupNode,
    index: tempIndex, // 保证插入节点在游戏树中位于热区组下面
  }
}

export function getBrainItemChildren(brain: IvBrainItem): IvBrainItem[] {
  const brainData: IvBrainItem[] = store.state.ivBrain.brainData
  let children: IvBrainItem[] = []
  if (brain.actions) {
    brain.actions.forEach((action) => {
      const temp = brainData.find(
        (item) => item.sceneUuid === action.targetUuid,
      )
      if (temp) {
        children.push(temp)
        children = children.concat(getBrainItemChildren(temp))
      }
    })
  }
  return children
}

export function getBrainItemByUuid(
  uuid: string,
  data?: IvBrainItem[],
): IvBrainItem | undefined {
  const brainData: IvBrainItem[] = data || store.state.ivBrain.brainData
  return brainData.find((item) => item.sceneUuid === uuid)
}

// 获取脑图节点所有后代节点
export function getBrainItemAllChildren(
  brain: IvBrainItem,
  isInclude = true,
): IvBrainItem[] {
  let brainArr: IvBrainItem[] = []
  if (isInclude) {
    brainArr.push(brain)
  }
  brainArr = brainArr.concat(getBrainItemChildren(brain))
  return brainArr
}

// 获取脑图父级节点
export function getParentBrainItem(
  brain: IvBrainItem,
): IvBrainItem | undefined {
  const brainData: IvBrainItem[] = store.state.ivBrain.brainData
  return brainData.find(
    (item) =>
      item.actions.map((action) => action.targetUuid).indexOf(brain.sceneUuid) >
      -1,
  )
}

export function deleteBrainItemAction(
  sceneUuid: string,
  targetUuid: string,
  filterUuids: string[],
): qc.Node | null {
  let brainData: IvBrainItem[] = _.cloneDeep(store.state.ivBrain.brainData)
  const brain = getBrainItemByUuid(sceneUuid, brainData)
  if (!brain) return null
  const targetAction = brain.actions.find(
    (item) => item.targetUuid === targetUuid,
  )
  if (targetAction) {
    brain.actions = brain.actions.filter(
      (item) => item.targetUuid !== targetAction.targetUuid,
    )
    brainData = brainData.filter(
      (item: IvBrainItem) => filterUuids.indexOf(item.sceneUuid) === -1,
    )
    store.commit('ivBrain/updateBrainData', brainData)
    return targetAction.nodeUuid ? nodePool.find(targetAction.nodeUuid) : null
  }
  return null
}

// 合并批量复制脑图节点中的重复部分
export function mergeCopyBrainItems(copyBrains: IvBrainItem[]) {
  const brainData: IvBrainItem[] = store.state.ivBrain.brainData
}

// 遍历pasteBrains脑图结构，根据脑图结构创建新脑图节点，并关联到目标脑图节点
// initList 收集创建脑图节点对应的场景节点
export async function addBrainItemByBrain(
  pasteBrains: IvBrainItem[],
  targetBrain: IvBrainItem,
  data: IvBrainItem[],
  initList: qc.Node[],
  initSpotList: qc.Node[],
  isAddSpot: boolean,
) {
  const promises = pasteBrains.map(async (item, index) => {
    const paste = _.cloneDeep(item)
    const sceneList = store.state.workspace.game.sceneManager.sceneList
    const sceneNode = await store.dispatch('workspace/sceneManager/copyScene', {
      uuid: item.sceneUuid,
      index: sceneList.length,
      isSwitchScene: false,
      record: false,
      isBatch: true,
    })
    paste.sceneUuid = sceneNode.uuid
    const target = getBrainItemByUuid(
      targetBrain.sceneUuid,
      data,
    ) as IvBrainItem
    if (isAddSpot) {
      // 目标节点新增热区
      const res = linkBrainItem(target.sceneUuid, sceneNode.uuid, data)
      if (res.hotSpot) {
        initSpotList.push(res.hotSpot)
      }
    } else {
      // 已有热区，修改热区配置
      target.actions[index].targetUuid = sceneNode.uuid
    }
    data.push(paste)
    initList.push(sceneNode)
    if (paste.actions.length) {
      const actionBrains = paste.actions.map(
        (el) => getBrainItemByUuid(el.targetUuid) as IvBrainItem,
      )
      await addBrainItemByBrain(
        actionBrains,
        paste,
        data,
        initList,
        initSpotList,
        false,
      )
    }
    return sceneNode
  })
  await Promise.all(promises)
  return {
    sceneList: initList,
    spotList: initSpotList,
  }
}
// 获取场景的link node
export function getIvSceneLinkNode(sceneUuid: string): qc.Node | null {
  const brainItem = getBrainItemByUuid(sceneUuid)
  if (brainItem) {
    return nodePool.find(brainItem.link.id)
  }
  return null
}

export function emptyBrainByVideoNode(
  nodes: qc.Node[],
  brainData: IvBrainItem[],
) {
  const toRemoveNodes: qc.Node[][] = []
  nodes.forEach((node) => {
    const brain = brainData.find(
      (item: IvBrainItem) => item.videoUuid === node.uuid,
    )
    if (brain) {
      const removeNodes = emptyBrain(brain)
      setTimeline(brain.sceneUuid, [])
      toRemoveNodes.push(removeNodes)
    }
  })
  return toRemoveNodes
}

export function emptyBrain(brainItem: IvBrainItem) {
  const getToRemoveNode = (scene: qc.Node): qc.Node[] => {
    return scene.children.filter(
      (item) =>
        ![IV_HOTAREA_GROUP_NAME, IV_SCENE_LINK_NODE_NAME].some(
          (el) => el === item.name,
        ),
    )
  }
  if (brainItem) {
    brainItem.videoUuid = ''
    brainItem.sync = IvSyncStatus.None
    const sceneNode = nodePool.find(brainItem.sceneUuid)
    return getToRemoveNode(sceneNode)
  }
  return []
}

export function getBrainItemActionIndexByNodeUuid(uuid: string): number {
  const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
  if (!currentSceneNode) return 1
  const brainItem = getBrainItemByUuid(currentSceneNode.uuid)
  if (!brainItem) return 1
  const index = brainItem.actions.findIndex(
    (action) => action.nodeUuid === uuid,
  )
  if (index === -1) {
    return 1
  }
  return index + 1
}
// 是否互动视频的结束场景
export function isIvEndScene(sceneNode: qc.Node): boolean {
  const sceneConfig = sceneConfigScript.getScript(sceneNode)
  if (!sceneConfig) return false
  return !!sceneConfig.isEnding
}

export function checkIsRootBrainItem(sceneUuid: string): boolean {
  const brainItem = getBrainItemByUuid(sceneUuid)
  const brainData: IvBrainItem[] = store.state.ivBrain.brainData || []
  const rootBrainItem = brainData && brainData.length > 0 ? brainData[0] : null
  if (!rootBrainItem || !brainItem) return false
  return brainItem.sceneUuid === rootBrainItem.sceneUuid
}

// 获取互动视频结束页的跳转商店热区
export function getIvEndingInstallNode(
  sceneNode: qc.Node,
): qc.Node | undefined {
  const node = sceneNode.children.find((child) => isIvEndingInstallNode(child))
  return node
}

export function getBrainIvTypeLabel(id: string): string {
  const brainItem = getBrainItemByUuid(id)
  const type = brainItem
    ? brainItem.link.interactiveType || brainItem.link.type
    : ''
  const option = unitTypeOptions.find((item: any) => item.value === type)
  return option ? String(option.label) : ''
}

export function getSceneCover(sceneUuid: string): string {
  const nodeConfig =
    store.state.workspace.editorConfig.nodeConfig[sceneUuid] || {}
  return nodeConfig.thumbnail || ''
}

export function getBrainIvTypeIcon(
  id: string,
  color: string,
  size: number,
): string {
  const brainItem = getBrainItemByUuid(id)
  const type = brainItem
    ? brainItem.link.interactiveType || brainItem.link.type
    : ''
  const option = unitTypeOptions.find((item: any) => item.value === type)
  return option ? option.svgString(color, size) : ''
}

// 检查是否允许切换互动跳转类型
export function checkCanSwitchIvType(sceneUuid: string, targetType: string) {
  // 规则
  // 1.当前为互动跳转，且存在多个热区，不允许切换为自动跳转
  const brainItem = getBrainItemByUuid(sceneUuid)
  if (brainItem) {
    if (
      brainItem.link.type === IvLinkType.Interactive &&
      targetType === IvLinkType.Auto
    ) {
      if (brainItem.actions.length > 1) {
        Message.error(
          i18n
            .t('interactiveVideo.iv.brain.node.unitType.rule.tipsa')
            .toString(),
        )
        return false
      }
    }
  } else {
    Message.error(
      i18n.t('interactiveVideo.iv.brain.node.unitType.rule.tipsb').toString(),
    )
    return false
  }
  return true
}

export function getBrainItemName(sceneUuid: string): string {
  const brain = getBrainItemByUuid(sceneUuid)
  if (!brain) return ''
  const sceneNode = nodePool.find(brain.sceneUuid)
  const isDefault = sceneNode.uniqueName.indexOf('New_Scene_') > -1
  const config = sceneConfigScript.getScript(sceneNode)
  if (config?.isEnding) {
    return String(i18n.t('interactiveVideo.iv.brain.node.enddingname'))
  }
  if (isDefault) {
    const videoNode = nodePool.find(brain.videoUuid)
    if (videoNode) {
      return getVideoNameByPath(videoNode.Video.videoUrl)
    }
    return String(i18n.t('interactiveVideo.iv.brain.node.videoname'))
  }
  return sceneNode.uniqueName
}

export function getClipSourcePath(
  path: string,
): { source: string; index: number } | null {
  let source = ''
  let index = 0
  const libClipPool = store.state.workspace.editorConfig.libClipPool
  const pathKeys = Object.keys(libClipPool)
  pathKeys.forEach((key) => {
    if (libClipPool[key].some((item: string) => item === path)) {
      source = key
      index = libClipPool[key].indexOf(path) + 1
    }
  })
  if (source) {
    return {
      source,
      index,
    }
  }
  return null
}

export function getVideoNameByPath(path: string): string {
  const config = poolVideoGetConfigByPath(path)
  if (config) {
    return config.name
  }
  // 通过裁剪map获取是否裁剪视频
  const sourceData = getClipSourcePath(path)
  const sourceConfig = poolVideoGetConfigByPath(
    sourceData ? sourceData.source : '',
  )
  if (sourceConfig && sourceData) {
    return `${sourceConfig.name}_Clip_${sourceData.index}`
  }
  return String(i18n.t('interactiveVideo.iv.brain.node.emptyNode.title'))
}

// 检查检查当前场景是否允许添加资源
export function checkCanAddResource(
  sceneUuid: string,
  category?: string,
): boolean {
  // 非互动视频编辑器，无添加资源限制
  if (!isIvPage()) return true
  const sceneNode = nodePool.find(sceneUuid)
  const currentBrain = getBrainItemByUuid(sceneUuid)

  if (!sceneNode || !currentBrain) return false

  // 忽略背景音乐拦截
  if (category === 'bgm') return true

  // 规则
  // 1.当前为结束场景禁止添加视频资源
  if (isIvEndScene(sceneNode) && category === 'video') {
    Message.error(
      String(i18n.t('interactiveVideo.iv.brain.node.video.rule.tipsa')),
    )
    return false
  }
  // 当前场景未添加视频资源
  if (
    !currentBrain.videoUuid &&
    !isIvEndScene(sceneNode) &&
    category !== 'video'
  ) {
    Message.error(
      String(i18n.t('interactiveVideo.iv.brain.node.video.rule.tipsb')),
    )
    return false
  }
  // // 当前场景已存在视频资源
  // if (currentBrain && currentBrain.videoUuid && category === 'video') {
  //   Message.error('未添加视频，已存在视频资源')
  //   return false
  // }
  return true
}

// todo 检查是否允许添加脑图节点
export function checkCanAddBrainItem(sceneUuid: string) {
  const sceneNode = nodePool.find(sceneUuid)
  const currentBrain = getBrainItemByUuid(sceneUuid)
  if (!sceneNode || !currentBrain) return false
  // 1.当前场景为结束场景，不允许添加脑图节点
  const config = sceneConfigScript.getScript(sceneNode)
  if (config?.isEnding) {
    Message({
      message: i18n.t('interactiveVideo.iv.brain.rule.endding') as string,
      type: 'error',
      duration: 5 * 1000,
    })
    return false
  }
  // 2.当前场景为自动跳转，不允许添加脑图节点（如果自动切换为互动，需要目前会触发两步历史记录是否ok）
  // 分支上最后一个视频节点如果是自动跳转，可以允许添加节点
  if (
    currentBrain.link.type === IvLinkType.Auto &&
    !isLastNormalScene(sceneNode)
  ) {
    Message({
      message: i18n.t(
        'interactiveVideo.iv.brain.node.video.rule.tipsc',
      ) as string,
      type: 'error',
      duration: 5 * 1000,
    })
    return false
  }
  return true
}

export function getJumpSceneUuidByNodeUuid(nodeUuid: string): string | null {
  const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
  if (!currentSceneNode) return null
  const brainItem = getBrainItemByUuid(currentSceneNode.uuid)
  if (!brainItem) return null
  const action = brainItem.actions.find((item) => item.nodeUuid === nodeUuid)
  if (action) {
    return action.targetUuid
  }
  if (brainItem.actions.length > 0) {
    return brainItem.actions[0].targetUuid
  }
  return null
}

export function getRelativeSameVideoSceneNode(sceneUuid: string): qc.Node[] {
  const currentSceneNode = nodePool.find(sceneUuid)
  if (!currentSceneNode) {
    return []
  }
  const brainItem = getBrainItemByUuid(currentSceneNode.uuid)
  // 当前节点为同步状态才获取关联视频
  if (brainItem && brainItem.sync !== IvSyncStatus.Sync) {
    return []
  }
  const nodes = getSameVideoScene(currentSceneNode, [IvSyncStatus.Sync], false)
  return nodes
}
